import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"

import useDoctorImage from "../../../components/choose-plan/hooks/use-doctor-image"

const PageHeader = ({
  heading = "Haut ist individuell. Dein FORMEL SKIN-Set auch.",
  className = "",
}) => {
  const { image } = useDoctorImage()

  return (
    <div
      sx={{
        my: 3,
        display: "grid",
        gridTemplateColumns: "1fr auto",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 3,
      }}
      className={className}
    >
      <Heading sx={{ lineHeight: "body" }}>{heading}</Heading>
      <GatsbyImage image={getImage(image)} alt="" width={64} height={64} />
    </div>
  )
}

export default PageHeader
